import { TeamTranslations } from "./team-pt-br";

export const TEAM_ES_MX: TeamTranslations = {
	custom: "Personalizado",
	showTableByBar: "Mostrar tabla por bar",
	noEmployees: "Ningún colaborador encontrado",
	notifications: {
		removeEmployee: "Colaborador eliminado con éxito",
		removeMultipleEmployees: "Colaboradores eliminados con éxito",
		addEmployee: "Colaborador creado con éxito",
		addZigTagToWaiter: "ZigTag añadido con éxito",
		addMultipleEmployees: {
			error: "Error al crear colaboradores:",
			success: "Colaboradores creados con éxito:",
		},
		editEmployee: "Colaborador editado con éxito",
		editMultipleEmployees: "Colaboradores editados con éxito",
		changePlace_one: "¡Colaborador transferido con éxito!",
		changePlace_other: "¡Colaboradores transferidos con éxito!",
		changePlaceError: "Error al cambiar de lugar",
	},
	header: {
		titleOrg: "Equipo",
		titlePlace: "Operadores de PDV",
		descriptionOrg:
			"Agregar, editar y eliminar colaboradores de la Organización (usuarios del panel de control).",
		descriptionPlace: "Agregar, editar y eliminar operadores de PDV en {{ placeName }}",
		alert: {
			link: "acceda a la sección de equipo de la organización.",
			text: "Para agregar colaboradores del panel de control o administrar cargos,",
		},
		searchPlaceholder: "Buscar",
		searchEmployee: "Buscar colaborador",
		filterByPlace: "Filtrar por lugar",
		closeSearch: "Cerrar",
		cleanSearch: "Limpiar",
		closeFilter: "Cerrar filtro",
		cleanFilter: "Limpiar filtro",
	},
	headerActions: {
		addEmployee: "Agregar colaborador",
		importEmployees: "Importar colaboradores",
		selectAllEmployee: "Seleccionar todos los colaboradores ({{ count }})",
		editSelectedCollaborator_one: "Editar colaborador seleccionado ({{count}})",
		editSelectedCollaborator_other: "Editar colaboradores seleccionados ({{count}}) ",
		deleteSelectedCollaborator_one: "Eliminar colaborador seleccionado ({{count}})",
		deleteSelectedCollaborator_other: "Eliminar colaboradores seleccionados ({{count}}) ",
		uncheckEmployee_one: "Desmarcar colaborador seleccionado ({{count}})",
		uncheckEmployee_other: "Desmarcar colaboradores seleccionados ({{count}}) ",
		changePlaceSelectedCollaborator_one:
			"Cambiar lugar del colaborador seleccionado ({{count}})",
		changePlaceSelectedCollaborator_other:
			"Cambiar lugar de los colaboradores seleccionados ({{count}})",
		buttonBulkActions: {
			titleBtn: "Acciones en masa",
			titleModal: "Acciones en masa ({{ count }} seleccionados)",
			titleModalMode: "Modo de selección",
			removeSelected: "Eliminar selección de los operadores ({{count}})",
			selectAllByRole: "Seleccionar todos los operadores por cargo",
			selectRole: "Seleccionar todos los {{name}}",
			titleRole: "Personalizado",
			editSelectedCollaborator_one: "Editar colaborador seleccionado",
			editSelectedCollaborator_other: "Editar colaboradores seleccionados",
			deleteSelectedCollaborator_one: "Eliminar colaborador seleccionado",
			deleteSelectedCollaborator_other: "Eliminar colaboradores seleccionados",
			changePlaceSelectedCollaborator_one: "Cambiar lugar del colaborador seleccionado",
			changePlaceSelectedCollaborator_other:
				"Cambiar lugar de los colaboradores seleccionados",
		},
	},
	columns: {
		name: "Colaborador",
		username: "Inicio de sesión",
		role: "Cargo",
		pub: {
			none: "Ningún bar",
			label: "Bares",
			mainBar: "Bar principal",
			bars: "Bares secundarios",
		},
		places: "Lugares",
		placesNone: "Ningún lugar seleccionado",
		deleteEmployee: "Eliminar colaborador",
		updateEmployee: "Editar colaborador",
		duplicateEmployee: "Duplicar colaborador",
		changePlace: "Cambiar lugar",
	},
	form: {
		create: {
			title: "Nuevo Operador",
			descriptionOrg:
				"Crea un colaborador de la organización (usuario del panel de control)",
			descriptionPlace: "Crea un operador en {{ placeName }}",
		},
		update: {
			title: "Editar Operador",
			descriptionOrg:
				"Edita un colaborador de la organización (usuario del panel de control)",
			descriptionPlace: "Edita un operador en {{ placeName }}",
		},
		multipleUpdate: {
			title: "Editar Operadores {{count}}",
			descriptionOrg:
				"Edita los colaboradores seleccionados de la organización (usuario del panel de control)",
			descriptionPlace: "Edita {{count}} operadores en {{ placeName }}",
			warning: {
				title: "Campos no completados",
				description:
					"Los campos no completados mantienen los valores originales del colaborador.",
			},
		},
		actions: {
			discardCreate: "Descartar creación",
			discardEdit: "Descartar cambios",
			create: "Crear colaborador",
			save: "Guardar cambios",
		},
		dataEmployees: {
			title: "Datos del Colaborador",
			name: {
				label: "Nombre",
				placeholder: "Ingrese el nombre",
				required: "El nombre es obligatorio",
				min: "El nombre debe tener al menos 3 caracteres",
			},
			username: {
				label: "Usuario",
				placeholder: "Ingrese el usuario",
				required: "El usuario es obligatorio",
				lowercase: "El usuario debe estar en minúsculas",
				noSpaces: "El usuario no puede contener espacios",
				tooltip: "El usuario debe ser único",
			},
			password: {
				label: "Contraseña",
				placeholder: "Cree la contraseña de acceso",
				required: "La contraseña es obligatoria",
				min: "La contraseña debe tener al menos 6 caracteres",
				notEmpty: "La contraseña no puede estar vacía",
			},
		},
		renameDataEmployees: {
			title: "Nombre",
			name: {
				label: "Renombrar",
				placeholder: "Renombrar colaboradores en masa",
			},
			initialNameNumber: {
				label: "Numerar a partir de",
				placeholder: "Ingrese el valor inicial",
				nonnegative: "El valor debe ser mayor que 0",
			},
			renameInitialNameNumber: {
				validation: "Los campos deben ser completados juntos",
				required: "Este campo es obligatorio",
			},
			info:
				"Al renombrar en masa, todos los colaboradores seleccionados tendrán el mismo nombre. Para diferenciarlos, los numeramos automáticamente a partir del número que ingrese en el cuadro de texto anterior.",
		},
		placeSection: {
			title: "Lugares",
			selectedPlaces: {
				required: "Debe seleccionar al menos un lugar",
				selectAll: "Seleccionar todos",
				none: "Ningún lugar seleccionado",
				min: "Debe seleccionar al menos un lugar",
			},
		},
		extraInfoSection: {
			title: "Información Extra",
			pub: {
				label: "Bares",
				labelMainBar: "Bar principal / punto de venta",
				placeholder: "Seleccione un bar de {{ placeName }}",
				required: "Debe seleccionar al menos un bar principal",
			},
			fichasAmount: {
				label: "Cantidad de vías en ficha",
				placeholder: "Ingrese la cantidad",
				nonnegative: "La cantidad debe ser mayor o igual a 0",
			},
			menuVisualizationType: {
				label: "Visualización del menú",
				placeholder: "Ingrese la cantidad",
				tooltip: {
					Grid: "Foto grande: 2 columnas",
					SmallGrid: "Foto pequeña: 3 columnas",
					NoPicture: "Sin foto: 3 columnas",
				},
				type: {
					Grid: "Foto grande",
					SmallGrid: "Foto pequeña",
					NoPicture: "Sin foto",
				},
			},
		},
		rolesAndPermissions: {
			titleOrg: "Cargos y Permisos del Dashboard",
			titlePlace: "Cargos y Permisos del PDV",
			employeeRole: {
				label: "Cargo",
				placeholder: "Seleccione un cargo",
				none: "Ningún cargo",
				custom: "Personalizado",
				required: "El cargo es obligatorio",
				selectAtLeastOnePermission:
					"Debe seleccionar al menos una permiso adicional de PDV",
			},
			zigTag: {
				label: "ZigTag",
				placeholder: "Ingrese el número del ZigTag",
				nonnegative: "El valor debe ser mayor o igual a 0",
			},
			permissions: {
				operationalPermissions: "Permisos de PDV",
				managerialPermissions: "Permisos gerenciales del PDV",
				permissionsOrg: "Acceso al dashboard",
			},
			type: {
				label: "Tipo de colaborador",
				placeholder: "Ninguno",
				invalid: "Tipo de colaborador inválido",
			},
		},
		moreThanOneEmployee: {
			title: "Agregar más de un colaborador",
			initialValue: "Ingrese valor inicial",
			finalValue: "Ingrese valor final",
			validationUntil: "El valor final debe ser mayor que el inicial",
			negativeValue: "Los valores deben ser mayores que 0",
			required: "Los campos son obligatorios",
			nonnegative: "El valor debe ser mayor o igual a 0",
			since: {
				label: "Desde",
			},
			until: {
				label: "Hasta",
			},
		},
		changePlace: {
			title: "Cambiar el lugar de los colaboradores",
			description:
				"Seleccione un nuevo lugar para los colaboradores seleccionados: {{ employeeNames }}",
			place: {
				label: "Lugar",
				placeholder: "Seleccione un lugar",
				required: "El lugar es obligatorio",
			},
			mainBar: {
				label: "Bar principal",
				placeholder: "Seleccione un bar",
			},
			barIds: {
				label: "Bares",
				placeholder: "Seleccione uno o varios bares",
			},
		},
		changePlaceEmployee: {
			place: {
				required: "El lugar es obligatorio",
			},
		},
	},
	deleteEmployeeModal: {
		title: "¿Desea eliminar colaborador?",
		description:
			"Al eliminar colaborador, su usuario será invalidado. Esta acción no se puede deshacer.",
		buttonCancel: "Cerrar",
		buttonConfirm_one: "Eliminar colaborador ({{ count }})",
		buttonConfirm_other: "Eliminar colaboradores ({{ count }})",
	},
	reportPrint: {
		title: "Importar colaboradores",
		btnDownloadTemplate: "Descargar plantilla",
		spreadsheet: "Importar hoja de cálculo",
		sheetFileName: "Colaboradores",
		sheetColumns: {
			name: {
				label: "Nombre del Colaborador",
				sample: "William",
			},
			username: {
				label: "Usuario",
				sample: "willzig",
			},
			password: {
				label: "Contraseña",
				sample: "123456",
			},
			zigTag: {
				label: "ZigTag (opcional)",
				sample: "123Z7JH",
			},
			fichasAmount: {
				label: "Cantidad de vías en ficha",
				sample: "2",
			},
			multiple: {
				label: "Cantidad para agregar en lote",
				sample: "1",
			},
		},
		role: {
			label: "Cargo",
			placeholder: "Seleccione un cargo",
			none: "Ningún cargo",
			custom: "Personalizado",
		},
		pub: {
			label: "Bares",
			labelMain: "Bar principal",
			placeholder: "Seleccione un bar",
			none: "Ningún bar",
		},
		permissions: {
			label: "Permisos",
		},
		info:
			"Todos los empleados serán agregados en {{ placeName }} con el cargo y bar seleccionados arriba",
		discard: "Descartar importación",
		finalize: "Finalizar importación",
	},
	validateTeamReport: {
		emptySheet: "No se encontraron datos en la hoja",
		existingEmployees: "Empleados existentes: {{ usernames }}",
		duplicateUsernames: "Se encontraron logins duplicados: {{ usernames }}",
		invalidSheet: "Datos inválidos encontrados: {{ errors }}",
		invalidRow: "Fila {{ index }}: {{ errors }}",
		invalid: {
			name: "Nombre inválido",
			username: "Login inválido",
			usernameChars: "El login contiene caracteres inválidos",
			password: "Contraseña inválida",
			multiple: "Valor múltiple inválido",
			multipleGreaterThan: "Múltiple mayor al permitido",
		},
	},
	duplicate: {
		success: "Colaborador duplicado con éxito",
		error: "Error al duplicar colaborador",
		title: "Duplicar colaborador",
		form: {
			description: "Al duplicar un colaborador, se importan todas sus permisses.",
			name: {
				label: "Nombre",
				placeholder: "Ingrese el nombre",
				required: "El nombre es obligatorio",
				min: "El nombre debe tener al menos 3 caracteres",
			},
			username: {
				label: "Usuario",
				placeholder: "Ingrese el usuario",
				required: "El usuario es obligatorio",
				lowercase: "El usuario debe estar en minúsculas",
				noSpaces: "El usuario no puede contener espacios",
			},
			password: {
				label: "Contraseña",
				placeholder: "Cree la contraseña de acceso",
				required: "La contraseña es obligatoria",
				notEmpty: "La contraseña no puede estar vacía",
			},
			submit: "Crear cópia de colaborador",
			close: "Cerrar",
		},
	},
};
